import { gql } from "@apollo/client";

// ─── shared field fragments ──────────────────────────────────────────────
export const MANUAL_REPORT_ENTRY_FIELDS = `
  id
  employeeId
  employeeName
  year
  monthIndex
  month
  week
  day
  date
  attendance {
    loginTime
    logoutTime
    breakIn
    breakOut
    permissions
    duration
  }
  countsJson
  leadIds
  remarks
  meetings
  complaints
  mgmtRemarks
  updatedAt
  updatedBy
`;

// ─── queries ─────────────────────────────────────────────────────────────
export const GET_MANUAL_REPORT_ROLE_CONFIG = gql`
  query {
    getManualReportRoleConfig {
      configJson
    }
  }
`;

export const GET_MY_MANUAL_REPORT_ROLE = gql`
  query {
    getMyManualReportRole {
      id
      employeeId
      employeeName
    }
  }
`;

export const GET_MY_MANUAL_REPORTS = gql`
  query ($year: Int!, $monthIndex: Int!) {
    getMyManualReports(year: $year, monthIndex: $monthIndex) {
      ${MANUAL_REPORT_ENTRY_FIELDS}
    }
  }
`;

export const GET_TEAM_MANUAL_REPORTS = gql`
  query ($fromDate: String!, $toDate: String!, $employeeIds: [String]) {
    getTeamManualReports(
      fromDate: $fromDate
      toDate: $toDate
      employeeIds: $employeeIds
    ) {
      ${MANUAL_REPORT_ENTRY_FIELDS}
    }
  }
`;

export const GET_MANUAL_REPORT_PERIOD_SUMMARY = gql`
  query ($fromDate: String!, $toDate: String!, $employeeIds: [String]) {
    getManualReportPeriodSummary(
      fromDate: $fromDate
      toDate: $toDate
      employeeIds: $employeeIds
    ) {
      fromDate
      toDate
      entryCount
      memberCount
      teamTotalsJson
      teamKpiJson
      perMember {
        employeeId
        employeeName
        entryCount
        totalsJson
        kpiJson
      }
    }
  }
`;

export const LIST_MANUAL_REPORT_TEAM_MEMBERS = gql`
  query {
    listManualReportTeamMembers {
      employeeId
      name
      entryCount
    }
  }
`;

// ─── mutations ───────────────────────────────────────────────────────────
export const UPSERT_MY_MANUAL_REPORT_ENTRY = gql`
  mutation (
    $year: Int!
    $monthIndex: Int!
    $week: Int!
    $day: String!
    $attendanceJson: String
    $countsJson: String
    $leadIds: String
    $remarks: String
    $meetings: String
    $complaints: String
  ) {
    upsertMyManualReportEntry(
      year: $year
      monthIndex: $monthIndex
      week: $week
      day: $day
      attendanceJson: $attendanceJson
      countsJson: $countsJson
      leadIds: $leadIds
      remarks: $remarks
      meetings: $meetings
      complaints: $complaints
    ) {
      ${MANUAL_REPORT_ENTRY_FIELDS}
    }
  }
`;

export const UPDATE_MANUAL_REPORT_MGMT_REMARKS = gql`
  mutation ($entryId: String!, $mgmtRemarks: String!) {
    updateManualReportMgmtRemarks(entryId: $entryId, mgmtRemarks: $mgmtRemarks) {
      ${MANUAL_REPORT_ENTRY_FIELDS}
    }
  }
`;

export const EXPORT_MANUAL_REPORTS_EXCEL = gql`
  mutation ($fromDate: String!, $toDate: String!, $employeeIds: [String]) {
    exportManualReportsExcel(
      fromDate: $fromDate
      toDate: $toDate
      employeeIds: $employeeIds
    ) {
      filename
      base64
      status
      message
    }
  }
`;
